// extracted by mini-css-extract-plugin
module.exports = {"actionsPopover":"DeleteOfficeWindowRequests_actionsPopover__hQprH","actionsDropdownContent":"DeleteOfficeWindowRequests_actionsDropdownContent__1F3YN"};